module.exports = "<h4 class=background-heading>Licenses</h4> <p class=background-text><%- licenses %></p> ";


//////////////////
// WEBPACK FOOTER
// ./templates/licenses.html
// module id = 189
// module chunks = 0